import { render, staticRenderFns } from "./commentary.vue?vue&type=template&id=59f6a8b2&"
import script from "./commentary.vue?vue&type=script&lang=js&"
export * from "./commentary.vue?vue&type=script&lang=js&"
import style0 from "./commentary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports